// src/components/PhotoAnnotatorFooter.jsx
// import React from "react";

/**
 * Footer with Cancel + Keep buttons.
 *
 * Props:
 *  - onCancel: () => void
 *  - onKeep: () => void
 */
export function PhotoAnnotatorFooter({ onCancel, onKeep }) {
  return (
    <div className="photo-annotator-footer-row">
      <button
        type="button"
        className="photo-annotator-footer-button"
        onClick={onCancel}
      >
        Cancel
      </button>
      <button
        type="button"
        className="photo-annotator-footer-button photo-annotator-footer-button--save"
        onClick={onKeep}
      >
        Keep
      </button>
    </div>
  );
}

// previous
// // src/components/PhotoAnnotatorFooter.jsx
// import React from "react";

// /**
//  * Footer with Cancel + Save buttons.
//  *
//  * Props:
//  *  - onCancel: () => void
//  *  - onSave: () => void
//  */
// export function PhotoAnnotatorFooter({ onCancel, onSave }) {
//   return (
//     <div className="photo-annotator-footer-row">
//       <button
//         type="button"
//         className="photo-annotator-footer-button"
//         onClick={onCancel}
//       >
//         Cancel
//       </button>
//       <button
//         type="button"
//         className="photo-annotator-footer-button photo-annotator-footer-button--save"
//         onClick={onSave}
//       >
//         Save
//       </button>
//     </div>
//   );
// }
